import { render, staticRenderFns } from "./BetwNav.vue?vue&type=template&id=86c08ea8&scoped=true&"
import script from "./BetwNav.vue?vue&type=script&lang=js&"
export * from "./BetwNav.vue?vue&type=script&lang=js&"
import style0 from "./BetwNav.vue?vue&type=style&index=0&id=86c08ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c08ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAppBar,VBtn,VCol,VIcon,VImg,VRow,VSkeletonLoader})
